import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListAuthorPageIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: StoryListAuthorPageIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
